import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";
import noPicture from "../../assets/nopicture.png";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: "auto", // Redimensionar automaticamente a altura para manter a proporção
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	}
}));

const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");
	const safeImageUrl = imageUrl || noPicture;

	useEffect(() => {
		setBlobUrl("");
		setFetching(true);

		if (!imageUrl) {
			setFetching(false);
			return;
		}

		const fetchImage = async () => {
			try {
				const { data, headers } = await api.get(imageUrl, {
					responseType: "blob",
				});
				const url = window.URL.createObjectURL(
					new Blob([data], { type: headers["content-type"] })
				);
				setBlobUrl(url);
			} catch (error) {
				setBlobUrl(noPicture);
			}
			setFetching(false);
		};
		fetchImage();
	}, [imageUrl]);

	return (
		<ModalImage
			className={classes.messageMedia}
			smallSrcSet={fetching ? safeImageUrl : blobUrl || safeImageUrl}
			medium={fetching ? safeImageUrl : blobUrl || safeImageUrl}
			large={fetching ? safeImageUrl : blobUrl || safeImageUrl}
			alt="image"
			showRotate={true}
		/>
	);
};

export default ModalImageCors;
